<template>
  <div>
    <tree-node
      v-for="child in props.modelValue"
      :key="child.id"
      :id="child.id"
      :name="child.name"
      :children="child.children"
      :depth="0"
      :handle-clicked="handleClicked"
    ></tree-node>
  </div>
</template>

<script setup>
import TreeNode from "@/Tailwind/Components/Settings/Spaces/Tree/TreeNode";
import { defineEmits, defineProps } from "vue";

const emit = defineEmits(["clicked"]);

const props = defineProps({
  modelValue: Array,
  tenantId: String,
});

function handleClicked(id) {
  emit("clicked", id);
}
</script>
